<template>
  <div class="addcontrolPrice">
    <div class="tabWrap">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="150px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目名称" prop="projectId">
                    <el-select
                      v-model="dateForm.projectId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="changeProject"
                    >
                      <el-option
                        v-for="item in projectIdList"
                        :key="item.projectId"
                        :label="item.projectName"
                        :value="item.projectId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购计划事项" prop="bidPlanItem">
                    <el-select
                      v-model="dateForm.bidPlanItem"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="changeProjectSubName"
                    >
                      <el-option
                        v-for="item in projectsubList"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购计划编号" prop="bidPlanId">
                    <el-select
                      v-model="dateForm.bidPlanId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="changebidPlanCode"
                    >
                      <el-option
                        v-for="item in bidPlanCodeList"
                        :key="item.id"
                        :label="item.bidPlanCode"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目类别">
                    <el-input
                      v-model="dateForm.projectType"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="采购金额">
                    <el-input
                      v-model="dateForm.estimatePrice"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：" prop="bidPlanMethodKey">
                     <el-select
                      v-model="dateForm.bidPlanMethodKey"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="changeType"
                    >
                      <el-option
                        v-for="item in typeOption"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                    <!-- <el-input
                      v-model="dateForm.bidPlanMethodValue"
                    ></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否已取得决策依据">
                    <el-select
                      v-model="dateForm.isDecisionBase"
                      placeholder="请选择"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报单位/部门" prop="commitDeptId">
                    <el-input
                      v-model="dateForm.commitDeptName"
                      placeholder="请选择填报部门"
                      style="width: 79%"
                    ></el-input>
                    <el-button
                      @click="selectAttendDepart"
                      type="primary"
                      style="min-width: 60px"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="审核内容" prop="approveComment">
                    <el-input
                      type="textarea"
                      :rows="4"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.approveComment"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="审核金额" prop="approvePrice">
                    <el-input
                      type="textarea"
                      :rows="4"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.approvePrice"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="24">
                  <el-form-item label="说明">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dateForm.remark"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dateForm.attachmentList"
            @saveUpdateFile="saveUpdateFile"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left; width: 90%; margin-top: 20px"
        >
          <addApproveLine
            :addoredit="editFlag"
            :itemId="controlPriceId || 0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="dateForm.approveTemplateType"
            :subApproveName="dateForm.approveTemplateName || ''"
          ></addApproveLine>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="savecontrolPriceInfo(0)"
        >暂 存</el-button
      >
      <el-button type="primary" @click="savecontrolPriceInfo(2)"
        >提 交</el-button
      >
      <el-button type="info" @click="close">取 消</el-button>
    </div>
    <!--选择部门弹窗 -->
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import {
  getbidPlandetail,
  savecontrolPrice, //新增一条采购计划
  updatecontrolPrice, //更新一条采购计划
  getcontrolPricedetail, //获取一条采购计划信息
  getProjects, //获取采购计划里的项目
  getBidPlanNos, //根据项目部获取采购计划下拉框数据
  getSubProjects, //根据采购计划编号获取工程分项下拉框数据
  getBidTypeDic, //获取一级数据字典接口
} from "@/services/bidServices";
import { getAllProjectPassListService } from "@/services/engineering";
import { saveApproveFun,updateApproveFun } from "@/page/approveComponents/approve";
import addApproveLine from "@/page/approveComponents/NewApproveLine"; //新增审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import SelectDialog from "@/components/SelectDialog";

export default {
  name: "addcontrolPrice",
  components: {
    upLoadFileDialog, //上传附件
    addApproveLine,
    SelectDialog,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "bidmanager", //审批流类型
      approveClass: "BID_PRICE_CONTROLE",
      flag:false,  //是否保存过审批流
      editFlag: false, //false：新建 true：编辑
      deptIdList: [],
      typeOption: [],
      projectIdList: [], //所属项目下拉框
      bidPlanCodeList: [], //采购计划编号下拉框
      projectsubList: [], //工程分项名称
      controlPriceId: "", //存储id
      selectDialogVisible: false,
      dateForm: {
        id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        commitDeptName: "", //提报部门
        commitDeptId: "", //提报部门
        approveComment: "", //审核内容
        approvePrice: "", //审核金额
        bidPlanItem: "", //采购计划事项
        attachmentList: [], //采购计划附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        status: "", //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "controlprice",
        approveTemplateName: "控制价审核",
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: true,
      },
      planDetailTableData: [],
      rules: {
        bidPlanId: [
          { required: true, message: "请选择采购计划编码", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目", trigger: "change" },
          // {
          //   min: 1,
          //   max: 60,
          //   message: "长度在 1 到 60 个字符",
          //   trigger: "blur",
          // },
        ],
        bidPlanItem: [
          { required: true, message: "请选择采购计划事项", trigger: "change" },
        ],

        commitDeptName: [
          { required: true, message: "请选择提报部门", trigger: "change" },
        ],

        approveComment: [
          { required: true, message: "请填写审核内容", trigger: "blur" },
        ],
        approvePrice: [
          { required: true, message: "请填写审核金额", trigger: "blur" },
        ],
        bidPlanMethodKey: [
          { required: true, message: "请选择采购方式", trigger: "change" },
        ],
        // bidPlanItem: [
        //   { required: true, message: "请选择工程分项名称", trigger: "change" },
        // ],
      },
    };
  },
  created() {
    this.dateForm.applyUserName = sessionStorage.getItem("name");
    this.getProject(); //获取项目部下拉框数据
    this.getbidPlanType();

  },
  mounted() {
    let ch = document.documentElement.clientHeight - 60;
    try {
      document.getElementsByClassName("addcontrolPrice")[0].style.height =
        ch + "px";
    } catch (error) {
      console.log("-- tableHeight error\n", error);
    }

    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 60;
        document.getElementsByClassName("addcontrolPrice")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.dateForm.id = this.tabRouteParam?.id ?? 0;
      if (this.dateForm.id) {
        this.editFlag = true;
        //编辑 获取详情
        this.controlPriceId = this.tabRouteParam.id;
        this.getDetail(this.controlPriceId);
      }
    },
    getProject() {
      let param = {
        approveType: "bidPrice",
      };
      getProjects(param)
        .then((res) => {
          if (res.code == "10000000") {
            this.projectIdList = res.data || [];
          }
        })
        .catch(() => {});
    },

    //切换项目名称，获取采购计划编号下拉框数据
    changeProject() {
      let index = this.projectIdList.findIndex(
        (item) => item.projectId === this.dateForm.projectId
      );
      if (index !== -1) {
        this.dateForm.projectName = this.projectIdList[index].projectName;
      }
      this.projectsubList = [];
      this.dateForm.bidPlanItem = "";
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (this.dateForm.projectId) this.getProjectSubClass();
      this.getAllProject(); //获取项目部对应部门
    },
    changebidPlanCode() {
      if (!this.dateForm.projectId) return;
      if (!this.dateForm.bidPlanId) return;
      let index = this.bidPlanCodeList.findIndex(
        (item) => item.id === this.dateForm.bidPlanId
      );
      if (index !== -1) {
        this.dateForm.bidPlanCode = this.bidPlanCodeList[index].bidPlanCode;
      }
      this.getbidPlanInfo(this.dateForm.bidPlanId);
    },
    changeProjectSubName() {
      if (!this.dateForm.projectId) return;
      // let index = this.projectsubList.findIndex(
      //   (item) => item.projectSubName === this.dateForm.projectSubName
      // );
      // if (index !== -1) {
      //   this.dateForm.bidType = this.projectsubList[index].bidType;
      // }
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (!this.dateForm.bidPlanItem) return;
      this.getbidPlanCodes();
    },
     //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //切换类型
    changeType() {
      let index = this.typeOption.findIndex(
        (item) => item.label === this.dateForm.bidPlanMethodKey
      );
      if (index !== -1) {
        this.dateForm.bidPlanMethodKey = this.typeOption[index].label;
        this.dateForm.bidPlanMethodValue = this.typeOption[index].value;
      }
    },
    getbidPlanInfo(id) {
      let param = {};
      param.bidPlanId = id;
      getbidPlandetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm.projectType = res.data.projectType;
            this.dateForm.estimatePrice = res.data.estimatePrice;
            this.dateForm.isDecisionBase = res.data.isDecisionBase.toString();
            this.dateForm.bidPlanMethodKey = res.data.bidPlanMethodKey;
            this.dateForm.bidPlanMethodValue = res.data.bidPlanMethodValue;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    // 提交基本信息
    savecontrolPriceInfo(val) {
      this.$refs["ruleForm"].validate((valid) => {
        //val=0 暂存 2：提交
        if (valid) {
          this.dateForm.status = val;
          if (val == 0) {
            this.tempSaveContent();
            return;
          }
          if (this.approveParams.approveProcessDtoList.length < 1) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              // this.$alert(
              //   this.approveParams.approveProcessDtoList[i].jobName +
              //     " 节点未选择审批人员",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //   }
              // );
              this.$alert("未选择审批人员", "提示", {
                confirmButtonText: "确定",
              });
              return;
            }
          }
          let msg = "您确定提交吗, 是否继续?";
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      let param = {};
      param = { ...this.dateForm };

      if (!this.editFlag) {
        //新增控制价审核
        savecontrolPrice(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新控制价审核
        param.id = this.controlPriceId;
        updatecontrolPrice(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(this.controlPriceId);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    tempSaveContent() {
      // let data = { ...this.dateForm };
      let param = {};
      if (
        this.dateForm.approveTemplateType &&
        this.approveParams.approveProcessDtoList.length > 0
      ) {
        //撤回状态的合同暂存的时候保存审批流
        if (this.approveParams.approveProcessDtoList.length < 1) {
          this.$alert(" 未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        for (
          let i = 0;
          i < this.approveParams.approveProcessDtoList.length;
          i++
        ) {
          delete this.approveParams.approveProcessDtoList[i].type;
          if (
            this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
            null == this.approveParams.approveProcessDtoList[i].approveUserId
          ) {
            this.$alert("未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
      }
      param = { ...this.dateForm };

      if (!this.editFlag) {
        //新增控制价审核
        savecontrolPrice(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(res.data);
              } else {
                this.$message.success("暂存成功");
              }

              this.bus.$emit("tabClose", "controlPriceAdd");
              this.bus.$emit("navMenuChange", {
                routeId: "controlPrice",
              });

              this.clearDialogForm();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新控制价审核
        param.id = this.controlPriceId;
        updatecontrolPrice(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              // this.$message.success("暂存成功");
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(this.controlPriceId);
              } else {
                this.$message.success("暂存成功");
              }

              this.bus.$emit("tabClose", "controlPriceEdit");
              this.bus.$emit("navMenuChange", {
                routeId: "controlPrice",
              });
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    //创建审批流函数
    async saveApproveFun(id) {
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_PRICE_CONTROLE";
      let subType = "控制价审核";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的 ${subType}申请`;
      let apiName=this.flag?updateApproveFun:saveApproveFun
      let res = await apiName(this.approveParams);
      if (res.code == 10000000) {
        if (!this.editFlag) {
          this.$message.success("保存成功");

          this.bus.$emit("tabClose", "controlPriceAdd");
          this.bus.$emit("navMenuChange", {
            routeId: "controlPrice",
          });
          this.clearDialogForm();
        } else {
          this.$message.success("提交成功");
          this.bus.$emit("tabClose", "controlPriceEdit");
          this.bus.$emit("navMenuChange", {
            routeId: "controlPrice",
          });
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    //暂存保存审批流
    async saveTempApproveFun(id) {
      for (
        let i = 0;
        i < this.approveParams.approveProcessDtoList.length;
        i++
      ) {
        delete this.approveParams.approveProcessDtoList[i].type;
        if (
          this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
          null == this.approveParams.approveProcessDtoList[i].approveUserId
        ) {
          this.$alert("未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "READY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_PRICE_CONTROLE";
      let subType = "控制价审核";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的 ${subType}申请`;

      let res = await saveApproveFun(this.approveParams);
      if (res.code == 10000000) {
        this.$message.success("暂存成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    clearDialogForm() {
      this.dateForm = {
        id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        commitDeptName: "", //提报部门
        commitDeptId: "", //提报部门
        approveComment: "", //审核内容
        approvePrice: "", //审核金额
        bidPlanItem: "", //采购计划事项
        attachmentList: [], //采购计划附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        status: "", //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "controlprice",
        approveTemplateName: "控制价审核",
      };
    },
    close() {
      let that = this;
      if (!this.editFlag) {
        this.bus.$emit("tabClose", "controlPriceAdd");
      } else {
        this.bus.$emit("tabClose", "controlPriceEdit");
      }
      this.bus.$emit("navMenuChange", {
        routeId: "controlPrice",
      });

      this.clearDialogForm();
    },
    //获取一条信息
    getDetail(id) {
      let param = {};
      param.bidPriceId = id;
      getcontrolPricedetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = { ...this.dateForm, ...res.data };
            this.dateForm.isDecisionBase =  this.dateForm.isDecisionBase.toString();
            this.dateForm.attachmentList = res.data.attachmentList ?? [];
            this.getProjectSubClass();
            this.getbidPlanCodes();
            // this.dateForm.projectId = this.dateForm.projectId.toString();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    //根据项目获取采购计划编号下拉框数据
    getbidPlanCodes() {
      let reqParam = {
        approveType: "bidPrice",
        projectId: this.dateForm.projectId,
        bidPlanItem: encodeURIComponent(this.dateForm.bidPlanItem),
      };
      getBidPlanNos(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.bidPlanCodeList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //根据采购计划事项
    getProjectSubClass() {
      let reqParam = {
        approveType: "bidPrice",
        projectId: this.dateForm.projectId,
      };
      getSubProjects(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.projectsubList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //根据项目获取项目部名称
    getAllProject() {
      getAllProjectPassListService()
        .then((res) => {
          if (res.code == "10000000") {
            let projects= res.data
            let index =projects.findIndex(
              (item) => item.id === this.dateForm.projectId
            );
            if (index !== -1) {
              this.dateForm.commitDeptName = projects[index].deptName;
              this.dateForm.commitDeptId =  projects[index].deptId;
            }
          }
        })
        .catch(() => {});
    },

    closeDialog() {
      this.applyUserDiaVisible = false;
    },

    //存储附件
    saveUpdateFile(selectItems) {
      this.dateForm.attachmentList = selectItems;
    },
    //存储审批流模板类型
    saveApproveType(item) {
      this.dateForm.approveTemplateType = item.label;
      this.dateForm.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems,flag=false) {
      this.flag=flag
      this.approveParams.approveProcessDtoList = selectItems;
    },
    selectAttendDepart() {
      // 选择参会部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "attendDepart",
      };
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "attendDepart": // 参会部门
          this.dateForm.commitDeptName = data.departList[0].name;
          this.dateForm.commitDeptId = data.departList[0].id;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.addcontrolPrice {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px;
        // margin-top: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }
        .el-select {
          width: 100%;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

.screenPanel {
  text-align: left;
  height: auto;
}

.el-select {
  width: 100%;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 14px;
}

.el-select {
  margin-right: 10px;
}

/deep/ .el-date-editor--time {
  width: 130px;
}

/deep/ .el-container .el-main {
  height: auto;
}
.firstTab {
  width: 72%;
  margin-top: 20px;
}
.firstTab1 {
  width: 100%;
  margin-top: 20px;
}
@media only screen and(max-width:1610px) {
  .firstTab {
    width: 90%;
    margin-top: 20px;
  }
  .firstTab1 {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
